import type { ChangeEvent } from 'react';
import { useState } from 'react';
import { Heading, Input, Label, Modal, Spacer, Text, Toast, useToast } from '@zillow/constellation-10';
import { UmcCompanyOverviewWebApiHandler_resendInviteEmail } from '@zg-rentals/ts-user-management-client';
import { ModalFooter } from '@zg-rentals/rental-revenue-components';

interface ResendCompanyInviteModal {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  invitedUser: any;
  setShowResendInviteModal: (value: boolean) => void;
}

const ResendCompanyInviteModal = ({ invitedUser, setShowResendInviteModal }: ResendCompanyInviteModal) => {
  const [email, setEmail] = useState('');
  const { email: targetEmail, userName } = invitedUser;
  const [open, setOpen] = useState(true);
  const { enqueueToast } = useToast();

  const onSubmit = () => {
    UmcCompanyOverviewWebApiHandler_resendInviteEmail({ email })
      .then(() => {
        enqueueToast(<Toast tone="success">Invite email has been resent to {email}</Toast>);
        return;
      })
      .then(() => setShowResendInviteModal(false))
      .catch(() => {
        // todo
      });
  };

  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        setOpen(next);
        if (!next) setShowResendInviteModal(false);
      }}
      size={{ base: 'fullScreen', lg: 'md' }}
      header={
        <Heading level={6} fontFamily="heading-alt">
          Resend invite
        </Heading>
      }
      body={
        <>
          <Text asChild>
            <div>{`Please confirm ${userName}'s email address.`}</div>
          </Text>
          <Spacer css={{ marginBlockStart: 'xs' }}>
            <Label>Email:</Label>
          </Spacer>
          <Input value={email} onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value.trim())} />
        </>
      }
      footer={
        <ModalFooter
          submitText="Resend invite"
          onSubmit={onSubmit}
          onCancel={() => setShowResendInviteModal(false)}
          isSubmitDisabled={email !== targetEmail}
        />
      }
    />
  );
};

export default ResendCompanyInviteModal;
